export default __webpack_public_path__ + "static/media/1_13_logo.7cc688cf.png";